import React, { Fragment, useState, useEffect } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Fade from "react-reveal/Fade"
import Image from "../base/Image"
import Swiper from "react-id-swiper"
import "swiper/css/swiper.css"

import ProductSlideWrapper, {
  Container,
  CarouselArea,
  CircleLoader,
  MockupWrapper,
  SectionHeader,
} from "./productSlide.style"
import SlideMockup from "../../assets/images/screen.png"
import { SectionHeading, SectionText } from "../Section/Section"
const params = {
  slidesPerView: 5,
  centeredSlides: true,
  spaceBetween: 30,
  loop: true,
  autoplay: {
    delay: 2500,
  },
  grabCursor: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    1440: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
}
const ProductSlide = props => {
  const data = useStaticQuery(graphql`
    query {
      dataJson {
        productData {
          slogan
          title
          slider {
            id
            thumb_url {
              publicURL
            }
            link
            title
          }
        }
      }
    }
  `)
  const { slogan, title, slider } = data.dataJson.productData

  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
  }, [])
  return (
    <ProductSlideWrapper>
      <Container>
        <SectionHeader>
          <Fade up>
            <SectionText content={slogan} />
            <SectionHeading content={title} />
          </Fade>
        </SectionHeader>
        <CarouselArea>
          {loading ? (
            <Fragment>
              <MockupWrapper>
                <Image src={SlideMockup} alt="mockup" />
              </MockupWrapper>
              <Swiper {...params}>
                {slider.map((item, index) => (
                  <div key={index}>
                    <div>
                      <a href={item.link} className="item_wrapper">
                        <Image
                          src={item.thumb_url.publicURL}
                          alt={item.title}
                        />
                      </a>
                    </div>
                  </div>
                ))}
              </Swiper>
            </Fragment>
          ) : (
            <CircleLoader>
              <div className="circle"></div>
              <div className="circle"></div>
            </CircleLoader>
          )}
        </CarouselArea>
        {/* End of carousel section */}
      </Container>
    </ProductSlideWrapper>
  )
}

ProductSlide.propTypes = {
  secHeading: PropTypes.object,
  secText: PropTypes.object,
}

ProductSlide.defaultProps = {
  secText: {
    as: "span",
    display: "block",
    textAlign: "center",
    fontSize: "14px",
    letterSpacing: "0.15em",
    fontWeight: "700",
    color: "rgb(255,148,147)",
    mb: "10px",
  },
  secHeading: {
    textAlign: "center",
    fontSize: ["20px", "24px"],
    fontWeight: "400",
    color: "#0f2137",
    letterSpacing: "-0.025em",
    mb: "0",
  },
}

export default ProductSlide
